###
Global timezone is set to UTC in App.coffee, to match server timezone
###
class DateService extends BaseService
	@register()
	@inject 'DATE_FORMAT',
		'DATE_TIME_FORMAT'
		'DEFAULT_TIMEZONE'
		'localStorageService'
		'$window'

	initialize: ->
		moment.tz.setDefault(@getTimezone())

	format: (timestamp = null, showTime = true, withOffset = true) ->
		format = @getFormat(showTime, withOffset)

		return @getInstance(timestamp).format(format)

	getInstance: (timestamp = null) ->
		instance = moment().clone()

		if timestamp?
			if ('' + timestamp).length == 10
				instance = moment.unix(timestamp)
			else
				instance = moment(timestamp)

		return instance

	getFormat: (showTime = true, withOffset = true) ->
		if showTime != false
			format = @DATE_TIME_FORMAT

			if withOffset
				format += ' (\U\T\CZ)'
		else
			format = @DATE_FORMAT

		return format

	getTimezone: ->
		return @localStorageService.get('date.tz') || moment.tz.guess()

	toggleTimezone: ->
		timezone = @localStorageService.get('date.tz')

		if timezone != @DEFAULT_TIMEZONE
			timezone = @DEFAULT_TIMEZONE
		else
			timezone = moment.tz.guess()

		@localStorageService.set('date.tz', timezone)

		moment.tz.setDefault(timezone)
		@$window.location.reload()
